export default __webpack_public_path__ + "static/media/Sea_Uman_5.b436df8e.PNG";